export default "__VITE_ASSET__5eoJ9woT__"